// extracted by css-extract-rspack-plugin
export default {"header":"qI1B2L4EXgAB0GZv","content":"H2BKfc3C0R0TEYRU","actions":"fWbjqY7SGW8Fhfkl"};